import { Component, EventEmitter, Output, Input, } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  moduleId: module.id,
  selector: 'default-product-infografic',
  templateUrl: 'default-product-infografic.component.html',
  styleUrls: ['default-product-infografic.component.scss'],
})
export class DefaultProductInfograficComponent {

  @Input() hideButtons: boolean = false;
  @Input() title: string = 'This product needs fitments!';
  @Input() text: string;

  @Output() assignFitment: EventEmitter<any> = new EventEmitter();

  @Output() researchClick: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router
  ) {}

  onResearchClick() {
    this.researchClick.emit();
  }

  onAssignFitmentBtnClick() {
    this.assignFitment.emit();
  }
}
